import React, { useState } from "react";
import { Link } from 'react-router-dom'; 
import { Col, Row, Card, Container, Breadcrumb } from 'react-bootstrap';
import GWformClient from '../../modalPopup/GWformClient';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
// Importing the image file
import staticInv from "../../assets/images/static_inv.png";
import videoInv from "../../assets/images/video_inv.png";
import threeDInv from "../../assets/images/3d_inv.png";
import weddingWebsites from "../../assets/images/website.svg";
import stationery from "../../assets/images/wedding.svg";
import socialmedia from "../../assets/images/socialmedia.png";
import logos from "../../assets/images/logos.png";
import hstag from "../../assets/images/hstag.png";

function Wedding_related_stuff() {
    const navigate = useNavigate();
    // State to track active item and content for the second column
    const [activeItem, setActiveItem] = useState(null);
    const [cardData, setCardData] = useState("Select an item to view details.");

    // List of items and their corresponding data
    const listItems = [
        { id: 1, label: "Static Invites", content: "Input Details For", image: staticInv },
        { id: 2, label: "Video Invites", content: "Input Details For", image: videoInv },
        { id: 3, label: "3D Invites", content: "Input Details For", image: threeDInv },
        { id: 4, label: "Wedding Websites", content: "Input Details For", image: weddingWebsites },
        { id: 5, label: "Stationery", content: "Input Details For", image: stationery },
        { id: 6, label: "Social Media filters", content: "Input Details For", image: socialmedia },
        { id: 7, label: "Logos", content: "Input Details For", image: logos },
        { id: 8, label: "Hashtags", content: "Input Details For", image: hstag },
    ];

    // Handle click on a list item
    const handleListItemClick = (item) => {
        setActiveItem(item.id); // Set the active item
        setCardData(item.content); // Update the card data
    };


    const [transition, setTransition] = useState(''); // Manage transition state
        
          const handleNavigation = (path, animationClass) => {
            setTransition(animationClass); // Set the animation class
            setTimeout(() => {
              navigate(path); // Navigate after animation
              setTransition(''); // Reset transition state
            }, 800); // Match the animation duration
          };

    return (
        <>
            <Container className="pt-5">
                <Row className="pt-5 mb-3">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => handleNavigation('/Client/dashboard/Client_home', 'slide-right')}><i className="pi pi-angle-left"></i> Back</Breadcrumb.Item>
                        <Breadcrumb.Item active>Wedding Onboarding Form</Breadcrumb.Item>
                    </Breadcrumb>
                </Row>
                <Row className="mx-0 justify-content-center pt-3 serviceCol">
                    <Col
                         className={`first-col ${
                            activeItem ? "col-3" : "col-12"
                        } transition`}
                    >
                        <ul>
                            {listItems.map((item) => (
                                <li
                                    key={item.id}
                                    onClick={() => handleListItemClick(item)}
                                    className={`clickable ${
                                        activeItem === item.id ? "active" : ""
                                    }`}
                                >
                                    <Card className="border-0 shadow-sm p-2">
                                        <Card.Body className="border p-2" style={{ borderRadius: "5px" }}>
                                            <img
                                                
                                                src={item.image}
                                                alt={item.label}
                                                className="mb-3"
                                                style={{ width: "60px", height: "60px" }}
                                            />
                                            <h6>
                                                {item.label}
                                                <small className="d-block">Wedding related stuff</small>
                                            </h6>
                                        </Card.Body>
                                    </Card>
                                </li>
                            ))}
                        </ul>
                    </Col>
                    <Col
                        className={`second-col ${
                            activeItem ? "col-9 show" : "col hide"
                        } transition`}
                    >
                        <Card className="border-0">
                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                <h6><span className="text-secondary">{cardData}</span> - <b className="text-black">{listItems.find(item => item.id === activeItem)?.label || ""}</b></h6>
                                <Button
                                    severity="danger"
                                    outlined
                                    className="border-0 p-0"
                                    icon="pi pi-times"
                                    aria-label="Close" 
                                    onClick={() => setActiveItem(null)} 
                                />
                            </Card.Header>
                            <Card.Body>
                                <GWformClient />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <div className={`transition-overlay ${transition}`} />
        </>
    );
}

export default Wedding_related_stuff;